import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
// Assuming COLOURS is defined in your constants
import { COLOURS } from 'constants/index';

const useStyles = makeStyles({
  switchBase: {
    color: COLOURS.ENERGIZED,
    '&$checked + $track': {
      backgroundColor: COLOURS.STABLE,
    },
  },
  checked: {},
  track: {
    backgroundColor: COLOURS.STABLE,
  },
});

export default function TwoLabelSwitch({
  checked,
  handleChange,
  leftText,
  rightText,
  disabled = false,
}) {
  const classes = useStyles();

  return (
    <Grid component="label" container alignItems="center" justifyContent="flex-end">
      <Grid item>{leftText}</Grid>
      <Grid item>
        <Switch
          disabled={disabled}
          classes={{
            switchBase: classes.switchBase,
            checked: classes.checked,
            track: classes.track,
          }}
          color="primary"
          checked={checked}
          onChange={handleChange}
        />
      </Grid>
      <Grid item>{rightText}</Grid>
    </Grid>
  );
}

TwoLabelSwitch.defaultProps = {
  disabled: false,
};

TwoLabelSwitch.propTypes = {
  checked: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
  leftText: PropTypes.string.isRequired,
  rightText: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
};
